import React, { useEffect, useState } from 'react';
import { Menu, X, Leaf } from 'lucide-react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const closeMenu = () => setIsMobileMenuOpen(false);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-3' : 'bg-white/95 backdrop-blur-sm py-5'}`} data-id="element-135">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-136">
        <div className="flex justify-between items-center" data-id="element-137">
          {/* Logo */}
          <a href="#home" className="flex items-center gap-2 group" onClick={closeMenu} data-id="element-138">
            <div className="bg-emerald-600 p-2 rounded-lg group-hover:bg-emerald-700 transition-colors" data-id="element-139">
              <Leaf className="h-6 w-6 text-white" data-id="element-140" />
            </div>
            <span className="text-xl font-bold text-gray-900 tracking-tight" data-id="element-141">
              Green Valley <span className="text-emerald-600" data-id="element-142">Lawncare</span>
            </span>
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-143">
            <a href="#services" className="text-sm font-medium text-gray-700 hover:text-emerald-600 transition-colors" data-id="element-144">
              Services
            </a>
            <a href="#about" className="text-sm font-medium text-gray-700 hover:text-emerald-600 transition-colors" data-id="element-145">
              About Us
            </a>

            <a href="#contact" className="text-sm font-medium text-gray-700 hover:text-emerald-600 transition-colors" data-id="element-146">
              Contact
            </a>
            <a href="#contact" className="inline-flex items-center justify-center px-5 py-2.5 text-sm font-medium text-white bg-emerald-600 rounded-lg hover:bg-emerald-700 transition-colors shadow-sm hover:shadow focus:outline-none focus:ring-2 focus:ring-emerald-500 focus:ring-offset-2" data-id="element-147">
              Get Free Quote
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-gray-600 hover:text-emerald-600 hover:bg-emerald-50 rounded-lg transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle mobile menu" aria-expanded={isMobileMenuOpen} data-id="element-148">
            {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-149" /> : <Menu className="h-6 w-6" data-id="element-150" />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && <div className="md:hidden absolute top-full left-0 right-0 bg-white border-t border-gray-100 shadow-lg py-4 px-4 flex flex-col gap-4" data-id="element-151">
          <a href="#services" className="block px-4 py-2 text-base font-medium text-gray-700 hover:text-emerald-600 hover:bg-emerald-50 rounded-lg" onClick={closeMenu} data-id="element-152">
            Services
          </a>
          <a href="#about" className="block px-4 py-2 text-base font-medium text-gray-700 hover:text-emerald-600 hover:bg-emerald-50 rounded-lg" onClick={closeMenu} data-id="element-153">
            About Us
          </a>

          <a href="#contact" className="block px-4 py-2 text-base font-medium text-gray-700 hover:text-emerald-600 hover:bg-emerald-50 rounded-lg" onClick={closeMenu} data-id="element-154">
            Contact
          </a>
          <div className="pt-2 px-4" data-id="element-155">
            <a href="#contact" className="flex w-full items-center justify-center px-5 py-3 text-base font-medium text-white bg-emerald-600 rounded-lg hover:bg-emerald-700 transition-colors shadow-sm" onClick={closeMenu} data-id="element-156">
              Get Free Quote
            </a>
          </div>
        </div>}
    </header>;
}